import { Box, Typography } from '@mui/material';

import { useLanguage } from '../../hooks';
import { SuccessIcon } from '../icons';

const customStyles = {
  mainHeading: {
    fontFamily: 'Noto Sans',
    fontWeight: 500,
    fontStyle: 'Medium',
    fontSize: '24px',
    lineHeight: '32px',
    letterSpacing: '0%',
    textAlign: 'center',
    '@media (max-width: 600px)': {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  description: {
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontStyle: 'Regular',
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '0%',
    textAlign: 'center',
  },
  successIcon: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '40px',
  },
  successContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
  },
  successIconSvg: {
    width: '163px',
    height: '163px',
    '@media (max-width: 600px)': {
      width: '150px',
      height: '150px',
    },
  },
};

interface MfaSuccessProps {
  isMobile: boolean;
}

export const MfaSuccess = ({ isMobile = false }: MfaSuccessProps) => {
  const lang = useLanguage();

  return (
    <Box sx={customStyles.successContainer}>
      <Box sx={customStyles.successIcon}>
        <SuccessIcon sx={customStyles.successIconSvg} />
      </Box>
      <Typography sx={customStyles.mainHeading}>{lang.mfa.successTitle}</Typography>
      <Typography sx={customStyles.description}>
        {isMobile ? lang.mfa.successDescriptionMobile : lang.mfa.successDescription}
      </Typography>
    </Box>
  );
};
